











































































import { Component, Vue, Ref } from "vue-property-decorator";
import StepHead from "../Stepper/StepHead.vue";
import CarSerial from "../FormParts/CarForm/CarSerial.vue";
import CarDocument from "../FormParts/CarForm/CarDocument.vue";
import CarSignYear from "../FormParts/CarForm/CarSignYear.vue";
import CarModelHost from "_C/main/FormParts/CarForm/CarModelHost.vue";
import { InsuranceCard, Car, IdentifierType } from "@/services/index.defs";
import { GaHelper } from "@/core/helpers/ga";
import {RecentCardsHelper} from "@/core/helpers/RecentCardsHelper";
@Component({
    components: {
        CarModelHost,
        StepHead,
        CarSignYear,
        CarSerial,
        CarDocument
    }
})
export default class Step2 extends Vue {
    isValid = true;

    get cbVal(): boolean {
        return true;
    } //disabled

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    get car(): Car {
        return this.card.car;
    }

    async clearCar() {
        this.card.car = new Car();

        await this.$nextTick();
        this.card.car.documentCar.docDate = new Date();
        await this.$nextTick();
        this.card.car.documentCar.docDate = null;

        this.card.car.documentsCar.forEach(async (_, idx) => {
            this.card.car.documentsCar[idx].docDate = new Date();
            await this.$nextTick();
            this.card.car.documentsCar[idx].docDate = null;
        });
    }

    carModelHostIsEdit: boolean = false;
    @Ref("carModel") carModelHost: CarModelHost;
    errorMessage = "";

    @Ref("form") form: { validate: Function };
    async nextStep() {
        this.errorMessage = "";
        let isValid = this.form.validate();
        if (!this.carModelHost.form.validate()) {
            //check hidden form
            this.errorMessage = `Ошибка в модели автомобиля, исправьте чтобы продолжить`;
            return;
        }
        else this.carModelHost.saveCarModel()
        if (!isValid) {
            this.errorMessage = `Ошибка в данных автомобиля, исправьте чтобы продолжить`;
            return;
        }
        RecentCardsHelper.rememberCard(
            this.card,
            RecentCardsHelper.createCardName(this.$store, this.card)
        );
        this.$emit("next");
    }
    mounted() {
        GaHelper.send("car");
    }
}
